import { render, staticRenderFns } from "./UserPasswordChangeIsp.vue?vue&type=template&id=6790b7b3&"
import script from "./UserPasswordChangeIsp.vue?vue&type=script&lang=js&"
export * from "./UserPasswordChangeIsp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports